const mediaData = [
  {
    title: '吃瓜圆桌派：本月最劲爆八卦TOP10',
    desc: '本期节目盘点本月最受关注的十大八卦事件，嘉宾现场点评爆料内幕。',
    image: 'https://readdy.ai/api/search-image?query=Talk%20show%20studio%20set%20with%20warm%20lighting%20and%20comfortable%20seating%2C%20podcast%20recording%20atmosphere%2C%20coral%20and%20cream%20tones%2C%20professional%20video%20production%20quality&width=800&height=450&seq=media-card-01&orientation=landscape',
    duration: '45:28',
    views: '32.6万',
  },
  {
    title: '幕后揭秘：明星经纪团队的一天',
    desc: '独家揭秘一线明星经纪团队的真实工作状态，带你了解娱乐圈幕后的运作模式。',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20office%20with%20warm%20natural%20lighting%2C%20creative%20team%20working%2C%20modern%20workspace%2C%20coral%20and%20beige%20tones%2C%20documentary%20film%20style&width=800&height=450&seq=media-card-02&orientation=landscape',
    duration: '28:15',
    views: '18.9万',
  },
  {
    title: '八卦考古：那些年被我们遗忘的大瓜',
    desc: '回顾近十年娱乐圈最轰动的几大事件，当年闹得沸沸扬扬如今你还记得几个？',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20retro%20newspaper%20and%20magazine%20collage%20with%20warm%20vintage%20tones%2C%20entertainment%20history%20theme%2C%20soft%20coral%20and%20cream%20colors%2C%20editorial%20quality&width=800&height=450&seq=media-card-03&orientation=landscape',
    duration: '36:42',
    views: '25.1万',
  },
  {
    title: '独家专访：资深娱记谈行业现状',
    desc: '从业20年的资深娱乐记者分享行业内幕，讲述那些不为人知的采访故事。',
    image: 'https://readdy.ai/api/search-image?query=Professional%20interview%20setting%20with%20warm%20lighting%2C%20journalist%20atmosphere%2C%20modern%20studio%2C%20soft%20coral%20and%20beige%20tones%2C%20documentary%20interview%20style&width=800&height=450&seq=media-card-04&orientation=landscape',
    duration: '52:10',
    views: '41.3万',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-2">
          <span className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-secondary-100">
            <i className="ri-play-circle-line text-secondary-500 text-lg"></i>
          </span>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">视频专区</h2>
        </div>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10 pl-11 md:pl-12">精选视频内容，换个方式一起吃瓜</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {mediaData.map((item) => (
            <div
              key={item.title}
              className="rounded-2xl bg-background-50 border border-background-200/70 overflow-hidden hover:border-primary-200 transition-all cursor-pointer group"
            >
              <div className="relative w-full aspect-[16/9] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <span className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-white/90 text-primary-500 group-hover:scale-110 transition-transform">
                    <i className="ri-play-fill text-xl"></i>
                  </span>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-white text-xs">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 flex flex-col gap-2">
                <h3 className="font-heading font-bold text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-2">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 line-clamp-2">{item.desc}</p>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {item.views} 次观看
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}